import React, {cloneElement} from 'react';
import {Pressable, Text} from 'react-native';
import {tID} from '../../../utils/TestIdHelper';
import {useThemedStyles} from '../../../theme';
import makeStyles from './styles';
import {
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
} from '../../../utils/SvgIcons';

const Checkbox = ({
  checkedImage = <CheckboxCheckedIcon />,
  unCheckedImage = <CheckboxUncheckedIcon />,
  selected = false,
  title = '',
  onPress,
  topMargin = 24,
  titleStyle = {},
  numberOfLines,
  checkboxStyle,
}) => {
  const styles = useThemedStyles(makeStyles);
  let checkBoxIcon = unCheckedImage;
  if (selected) {
    checkBoxIcon = checkedImage;
  }
  return (
    <Pressable
      testID={tID('Checkbox-Pressable-Main')}
      style={[styles.container, {marginTop: topMargin}]}
      onPress={onPress}
    >
      {cloneElement(checkBoxIcon, {
        testID: tID('Checkbox-Image-Icon'),
        width: checkboxStyle?.width || 18,
        height: checkboxStyle?.height || 18,
        style: checkboxStyle,
      })}
      <Text
        testID={tID('Checkbox-Text-Title')}
        numberOfLines={numberOfLines}
        style={[styles.titleStyle, titleStyle]}
      >
        {title}
      </Text>
    </Pressable>
  );
};

export default Checkbox;
